var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUsersShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 74,
    viewBox: "0 0 91 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3736_5378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 31.5C24.8609 31.5 28 28.3609 28 24.5C28 20.6391 24.8609 17.5 21 17.5C17.1391 17.5 14 20.6391 14 24.5C14 28.3609 17.1391 31.5 21 31.5ZM70 31.5C73.8609 31.5 77 28.3609 77 24.5C77 20.6391 73.8609 17.5 70 17.5C66.1391 17.5 63 20.6391 63 24.5C63 28.3609 66.1391 31.5 70 31.5ZM73.5 35H66.5C64.575 35 62.8359 35.7766 61.5672 37.0344C65.975 39.4516 69.1031 43.8156 69.7812 49H77C78.9359 49 80.5 47.4359 80.5 45.5V42C80.5 38.1391 77.3609 35 73.5 35ZM45.5 35C52.2703 35 57.75 29.5203 57.75 22.75C57.75 15.9797 52.2703 10.5 45.5 10.5C38.7297 10.5 33.25 15.9797 33.25 22.75C33.25 29.5203 38.7297 35 45.5 35ZM53.9 38.5H52.9922C50.7172 39.5938 48.1906 40.25 45.5 40.25C42.8094 40.25 40.2938 39.5938 38.0078 38.5H37.1C30.1437 38.5 24.5 44.1438 24.5 51.1V54.25C24.5 57.1484 26.8516 59.5 29.75 59.5H61.25C64.1484 59.5 66.5 57.1484 66.5 54.25V51.1C66.5 44.1438 60.8562 38.5 53.9 38.5ZM29.4328 37.0344C28.1641 35.7766 26.425 35 24.5 35H17.5C13.6391 35 10.5 38.1391 10.5 42V45.5C10.5 47.4359 12.0641 49 14 49H21.2078C21.8969 43.8156 25.025 39.4516 29.4328 37.0344Z",
    fill: "#D4D8D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3736_5378",
    x: 0.5,
    y: 4.5,
    width: 90,
    height: 69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.847059 0 0 0 0 0.847059 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3736_5378"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3736_5378",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsersShadow);
export default __webpack_public_path__ + "static/media/IconUsersShadow.88178248de3b22df1e2eb117800a9877.svg";
export { ForwardRef as ReactComponent };